<script>
export default {
  name: 'WorkOrderCustomerSiteTab',
  props: {
    customerName: {
      type: [String, Number],
      required: true,
    },
    picName: {
      type: [String, Number],
      required: true,
    },
    picContact: {
      type: [String, Number],
      required: true,
    },
    latitude: {
      type: [String, Number],
      required: true,
    },
    longitude: {
      type: [String, Number],
      required: true,
    },
    sidebarRows: {
      type: Array,
      required: true,
    },
  },
}
</script>

<template>
  <article class="wo-panel wo-customer-panel">
    <h2>Customer and site</h2>

    <div class="wo-input-grid">
      <div class="wo-field-card">
        <div class="wo-field-card__header">
          <span>CUSTOMER</span>
          <span class="wo-source-badge">From ERP</span>
        </div>
        <div class="wo-field-card__value">{{ customerName }}</div>
      </div>
      <div class="wo-field-card">
        <div class="wo-field-card__header">PIC NAME</div>
        <div class="wo-field-card__value">{{ picName }}</div>
      </div>
      <div class="wo-field-card">
        <div class="wo-field-card__header">PIC CONTACT</div>
        <div class="wo-field-card__value">{{ picContact }}</div>
      </div>
    </div>

    <div class="wo-site-grid">
      <div class="wo-map-placeholder">
        <div class="wo-map-placeholder__pin">
          <i class="bx bx-map-pin"></i>
        </div>
        <div>
          <div class="wo-map-placeholder__title">Pin set from Google Maps</div>
          <div class="wo-map-placeholder__subtitle">lat {{ latitude }}, long {{ longitude }}</div>
        </div>
      </div>

      <div class="wo-site-summary">
        <div v-for="row in sidebarRows" :key="row.label" class="wo-summary-row">
          <span>{{ row.label }}</span>
          <strong>{{ row.value }}</strong>
          <em>{{ row.meta }}</em>
        </div>
      </div>
    </div>
  </article>
</template>
